var subsideOpen = -1;
var lastElement = null;

function displayOverlay(nummer){
    const subside = document.getElementsByClassName("subside")[nummer];
    const subsideContent = subside.getElementsByClassName("subside-content")[0];
    subside.style.display = "block";

    const body = document.body;
    body.style.overflow = "hidden";

    if(subsideContent.clientHeight >= subsideContent.scrollHeight) {
        subsideContent.style.overflow = "hidden";
    }
    subsideOpen = 0;
}
      
function hideOverlay(nummer){
    const subside = document.getElementsByClassName("subside")[nummer];
    subside.style.display = "none";

    const body = document.body;
    body.style.overflowY = "scroll";
    subsideOpen = -1;
}

function overflowContainers(kill) {
    const containers = document.getElementsByClassName("container");
    for(const container of containers) {
        if(kill) {
            container.style.overflow = "hidden";
        } else {
            container.style.overflow = "";
        }
    }
}
      
function scrollUp(element){
    if(element){
        scroll(0, element.offsetTop - window.innerHeight);
    }else{
        if((window.scrollY % window.innerHeight) > 1) {
            scroll(0,Math.floor(window.scrollY / window.innerHeight)*window.innerHeight);
        } else {
            scroll(0,window.scrollY-window.innerHeight);
        }
    }
}
      
function scrollDown(element){
    if(element){
        scroll(0,element.offsetTop + element.clientHeight);
    }else{
        if((window.scrollY % window.innerHeight) > 1) {
            scroll(0, Math.ceil(window.scrollY / window.innerHeight)*window.innerHeight);
        } else {
            scroll(0,window.scrollY+window.innerHeight);
        }
    }
}
      
function expandImage(element) {
    const bigs = Array.from(document.getElementsByClassName("big"));
    for(const big of bigs) {
        big.classList.remove("big");
    }

    const img = element.getElementsByTagName("img")[0];
    element.classList.add("big");
    img.classList.add("big");
}
    
window.onload = function(){
    if(window.innerHeight >= 600 && window.innerWidth >= 600) {
        const containers = document.getElementsByClassName("container");
        for(const container of containers){
            container.addEventListener("wheel", function(event){
                event.preventDefault();
                if(Boolean(subsideOpen)) {
                    if(event.deltaY > 0) {
                        scrollDown();
                    } else{
                        scrollUp();
                    }
                }
            });
        }
        const pictures = document.getElementsByClassName("picture");
        for(const picture of pictures) {
            picture.addEventListener("click", function(event) {
                expandImage(picture);
            }, false);
        }
    }
    const pfeileUnten = document.getElementsByClassName("pfeil-unten");
    for(const pfeilUnten of pfeileUnten){
        pfeilUnten.children[0].addEventListener("click", function(event) {
            scrollDown(pfeilUnten);
        });
    }
    const pfeileOben = document.getElementsByClassName("pfeil-oben");
    for(const pfeilOben of pfeileOben){
        if(pfeilOben.children.length > 0) {
            pfeilOben.children[0].addEventListener("click", function(event) {
                scrollUp(pfeilOben);
            });
        }
    }
}